import { ensureDate } from "@/utils/dateRange";
import type { DateRange } from "@/components/controls/DateRangePicker";

export const displaySelectedDates = (
  range: DateRange | null | undefined,
  formatFn: (date: Date) => string
) => {
  if (!range) return "";

  const fromDate = ensureDate(range.fromDate);
  if (!fromDate) return "";

  const toDate = ensureDate(range.toDate);
  if (!toDate || fromDate.getTime() === toDate.getTime()) {
    return formatFn(fromDate);
  }

  return `${formatFn(fromDate)} - ${formatFn(toDate)}`;
};
